module.exports = __webpack_public_path__ + "media/assets/icons/chat-bubble-ellipses-icon-purple-8e227b37fb9af85e46269b0f85b99dd9.png";